import React from "react";
import { Link } from "react-router-dom";
import AboutImage from "../../images/featured_seller.jpg";
import WhatsaAppIcon from "../../images/whatsapp.jpg";

const BeFeaturedSeller = () => {
  const whatsappURL = "https://wa.me/+923487172565";
  
  // Open WhatsApp URL
  const contact = () => window.open(whatsappURL, "_blank");
  
  return (
    <div className="relative flex flex-col md:flex-row items-center justify-between px-6 py-16 md:py-24 bg-gradient-to-r from-blue-50 to-indigo-50 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-blue-200 opacity-20"></div>
      <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-indigo-200 opacity-20"></div>
      
      <div className="relative z-10 bg-white p-8 md:p-10 rounded-2xl shadow-lg text-center md:text-left w-full md:w-7/12 lg:w-5/12 transform transition-all duration-300 hover:shadow-xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
          Want to use our services?
        </h1>
        <p className="text-gray-700 text-lg mb-8 leading-relaxed">
          What are you waiting for? Contact us right now if you want to <span className="font-semibold text-blue-600">buy or sell your car through us</span>, <span className="font-semibold text-blue-600">book a ride</span>, or <span className="font-semibold text-blue-600">register your showroom on NCPWheels</span>. We'll manage everything for you from top to bottom and keep you relaxed.
        </p>
        
        <div
          onClick={contact}
          className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-green-500 to-green-600 py-4 px-6 rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg cursor-pointer"
        >
          <img
            src={WhatsaAppIcon}
            className="w-8 h-8 rounded-full"
            alt="WhatsApp"
          />
          <span className="text-white font-semibold text-xl">
            Contact Us
          </span>
        </div>
      </div>

      <div className="relative z-10 w-full md:w-2/5 mt-10 md:mt-0">
        <div className="relative">
          <img
            src={AboutImage}
            alt="Car trading"
            className="w-full rounded-2xl shadow-lg transform transition-all duration-500 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
        </div>
        
        {/* Decorative element */}
        <div className="hidden lg:block absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gradient-to-r from-blue-400 to-indigo-500 opacity-20"></div>
      </div>
    </div>
  );
};

export default BeFeaturedSeller;